
{
  "familyId": "SPR-SAM-TUSSEN-N",
  "questions": [
    {
      "id": "SPR-SAM-TUSSEN-N-001",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "options": ["pannenkoek", "pannekoek", "pankoek", "pannen koek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-n regel", "content": "Bij samenstellingen met een meervoud op -en schrijf je een tussen-n.\n\npan → pannen (meervoud op -en)\npannen + koek = pannenkoek\n\nDe tussen-n komt van het meervoud. Denk: meerdere pannen → pannenkoek.", "icon": "book"}}
      ],
      "conceptId": "linking_n_pannenkoek",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Het eerste deel is 'pan'. Het meervoud van pan is 'pannen' (eindigt op -en). Bij samenstellingen gebruik je het meervoud: pannen + koek = pannenkoek. De tussen-n komt van het meervoud op -en. Samenstellingen schrijf je altijd aan elkaar — nooit met een spatie.",
        "solutionSteps": [
          "Bepaal het eerste deel: pan",
          "Maak het meervoud: pan → pannen (-en)",
          "Meervoud op -en → tussen-n in de samenstelling",
          "pannen + koek = pannenkoek (aan elkaar!) ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Pan → pannen → pannenkoek. De tussen-n komt van het meervoud.",
          "1": "Je bent de n vergeten. Het meervoud van 'pan' is 'pannen' (met n). Dus: pannenkoek, niet pannekoek.",
          "2": "Je hebt het eerste deel in het enkelvoud geschreven. Bij samenstellingen met een meervoud op -en gebruik je het meervoud: pannen + koek = pannenkoek.",
          "3": "Je hebt de tussen-n goed, maar het woord los geschreven. Samenstellingen schrijf je altijd aan elkaar: pannenkoek, niet 'pannen koek'."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.tussen-n-vergeten", "label": "Tussen-n vergeten", "optionIndex": 1 },
          { "id": "spr.tussen-n-enkelvoud", "label": "Enkelvoud i.p.v. meervoud", "optionIndex": 2 },
          { "id": "spr.samenstelling-gesplitst", "label": "Samenstelling los geschreven", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-007",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "categorize",
      "question": "Sorteer deze samenstellingen: welke hebben een tussen-n (-en) en welke hebben een tussen-e (-n valt weg)?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Tussen-n (meervoud -en)", "Tussen-e (n valt weg)"],
        "items": [
          {"text": "pannenkoek", "correctCategory": 0},
          {"text": "zonnebloem", "correctCategory": 1},
          {"text": "boekenplank", "correctCategory": 0},
          {"text": "zonnestraal", "correctCategory": 1},
          {"text": "fietsenrek", "correctCategory": 0},
          {"text": "zonneschijn", "correctCategory": 1}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-n vs. tussen-e — uniciteitsregel", "content": "De meeste samenstellingen met een meervoud op -en krijgen een tussen-n:\npannenkoek (meerdere pannen), boekenplank (meerdere boeken), fietsenrek (meerdere fietsen).\n\nMaar als het eerste deel naar iets unieks verwijst — er is maar één van — valt de -n weg:\nzonnebloem, zonnestraal, zonneschijn (er is maar één zon).\n\nDit heet de uniciteitsregel: uniek eerste deel → tussen-e.", "icon": "book"}}
      ],
      "conceptId": "linking_n_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Tussen-n (volledige meervoud -en): pannenkoek (pan → pannen), boekenplank (boek → boeken), fietsenrek (fiets → fietsen). Tussen-e (de -n valt weg): zonnebloem, zonnestraal, zonneschijn — allemaal met 'zon'. Bij 'zon'-samenstellingen is de tussen-e een uitzondering die je moet onthouden.",
        "solutionSteps": [
          "Pannenkoek: pan → pannen → tussen-n ✓",
          "Zonnebloem: zon → zonne- (n valt weg) → tussen-e",
          "Boekenplank: boek → boeken → tussen-n ✓",
          "Zonnestraal: zon → zonne- → tussen-e",
          "Fietsenrek: fiets → fietsen → tussen-n ✓",
          "Zonneschijn: zon → zonne- → tussen-e"
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-002",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welk woord is correct geschreven?",
      "options": ["zonbloem", "zonenbloem", "zonnenbloem", "zonnebloem"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Uniciteitsregel: één zon = geen -n", "content": "Bij samenstellingen schrijf je meestal het volledige meervoud (pan → pannen → pannenkoek).\n\nMaar als het eerste deel verwijst naar iets unieks — iets waarvan er maar één is — valt de -n weg en blijft alleen de -e. Er is maar één zon, dus:\nzonnebloem (één zon, niet meerdere)\nzonnestraal, zonneschijn.\n\nDit heet de uniciteitsregel: uniek → tussen-e i.p.v. tussen-en.", "icon": "book"}}
      ],
      "conceptId": "linking_n_zonnebloem",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij 'zonnebloem' schrijf je een tussen-e, niet een tussen-en. Dit volgt de uniciteitsregel: als het eerste deel naar iets unieks verwijst (er is maar één zon), valt de -n weg. Pas de regel stap voor stap toe: het meervoud van 'zon' is 'zonnen', maar omdat 'zon' uniek is, schrijf je in de samenstelling alleen zonne-: zonne + bloem = zonnebloem. Andere voorbeelden met de uniciteitsregel: zonneschijn, zonnestraal, maneschijn (één maan), hellevuur (één hel). Bij de meeste woorden gebruik je de volledige meervoudsvorm (pannenkoek = meerdere pannen, boekenplank = meerdere boeken).",
        "solutionSteps": [
          "Stap 1: Bepaal het eerste deel → zon",
          "Stap 2: Maak het meervoud → zonnen (-en)",
          "Stap 3: Pas de samenstellingsregel toe → normaal zou het 'zonnenbloem' zijn",
          "Stap 4: Controleer de uitzondering → bij 'zon' valt de -n weg",
          "Stap 5: Resultaat → zonne + bloem = zonnebloem"
        ],
        "distractorExplanations": {
          "0": "Je hebt geen verbindingsklank gebruikt. Pas de regel toe: zon → meervoud zonnen → in de samenstelling wordt dat zonne- (n valt weg). 'Zonbloem' slaat de meervoudsstap over.",
          "1": "'Zonenbloem' heeft maar één n. Pas de meervoudsregel toe: zon → zonnen (dubbele n, want korte klank + medeklinker). Maar de -n valt weg in de samenstelling: zonnebloem.",
          "2": "'Zonnenbloem' past de standaardregel toe (volledige meervoud -en). Maar 'zon'-samenstellingen zijn een uitzondering: de -n valt weg. Vergelijk: pannenkoek (standaard) vs. zonnebloem (uitzondering).",
          "3": "Goed! Zonnebloem — met tussen-e (de -n valt weg). Je hebt de uitzondering correct toegepast."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.tussen-n-enkelvoud", "label": "Enkelvoud i.p.v. meervoud", "optionIndex": 0 },
          { "id": "spr.tussen-n-vergeten", "label": "Tussen-n vergeten (één n)", "optionIndex": 1 },
          { "id": "spr.tussen-n-vergeten", "label": "Volledige -en i.p.v. tussen-e", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-003",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welke samenstelling heeft een tussen-n (de -en van het meervoud)?",
      "options": ["zonnebloem", "dorpsplein", "ruggengraat", "landbouwgrond"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-n herkennen", "content": "Een tussen-n komt van het meervoud op -en:\nrug → ruggen → ruggengraat (tussen-n)\n\nLet op het verschil:\n- Tussen-n (meervoud -en): ruggengraat, pannenkoek, boekenplank\n- Tussen-e (n valt weg): zonnebloem, zonneschijn\n- Tussen-s: dorpsplein, stadsmuur", "icon": "book"}}
      ],
      "conceptId": "linking_n_herkennen",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Ruggengraat heeft een tussen-n. Pas de regel toe: rug → ruggen (meervoud op -en) → ruggengraat. De andere woorden hebben andere verbindingsklanken: zonnebloem (tussen-e, uitzondering), dorpsplein (tussen-s), landbouwgrond (geen verbindingsklank). Regel: om het type verbindingsklank te bepalen, maak je eerst het meervoud. Eindigt het op -en? Dan is er een tussen-n. Hoor je een -s? Dan een tussen-s.",
        "solutionSteps": [
          "Stap 1: Analyseer elk woord — wat is het eerste deel en welke verbindingsklank hoor je?",
          "Ruggengraat: rug → ruggen (-en) → tussen-n ✓",
          "Zonnebloem: zon → zonnen, maar -n valt weg → tussen-e (uitzondering)",
          "Dorpsplein: dorp → je hoort een -s → tussen-s",
          "Landbouwgrond: landbouw + grond → geen extra klank"
        ],
        "distractorExplanations": {
          "0": "Zonnebloem heeft een tussen-e, niet een tussen-n. Pas de regel toe: zon → zonnen, maar bij 'zon'-samenstellingen valt de -n weg. Vergelijk: ruggengraat (standaard -en) vs. zonnebloem (uitzondering).",
          "1": "Dorpsplein heeft een tussen-s, niet een tussen-n. Spreek het uit: je hoort 'dorps-plein' (een -s). Bij een tussen-n zou je '-en' horen, zoals bij 'ruggen-graat'.",
          "2": "Goed! Rug → ruggen → ruggengraat. De -en van het meervoud is de tussen-n. Je hebt de meervoudsregel correct toegepast.",
          "3": "Landbouwgrond heeft geen verbindingsklank. Spreek het uit: 'landbouw-grond' — je hoort niets extra's. Bij een tussen-n zou je '-en' horen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.tussen-s-verward-en", "label": "Tussen-e verward met tussen-n", "optionIndex": 0 },
          { "id": "spr.tussen-s-verward-en", "label": "Tussen-s verward met tussen-n", "optionIndex": 1 },
          { "id": "spr.tussen-s-verward-en", "label": "Geen verbindingsklank verward met tussen-n", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-006",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "error_spotting",
      "question": "Zoek de spelfout in de zin en verbeter het woord.",
      "data": {
        "text": "Mijn moeder zette de bloemen in een bloemevase op de tafel.",
        "errors": [
          {
            "word": "bloemevase",
            "position": 9,
            "correction": "bloemenvaas",
            "explanation": "Bloem → bloemen (meervoud op -en). De samenstelling is bloemen + vaas = bloemenvaas. Let ook op: 'vaas' (met dubbele a), niet 'vase'."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-n in samenstellingen", "content": "Bij samenstellingen met een meervoud op -en schrijf je de volledige meervoudsvorm:\nbloem → bloemen → bloemenvaas\n\nDe tussen-n komt van het meervoud. Spreek het uit: bloemen-vaas.", "icon": "book"}}
      ],
      "conceptId": "linking_n_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Bloemevase' bevat twee fouten: de tussen-n ontbreekt (bloeme → bloemen) en 'vaas' is fout gespeld (vase → vaas). De samenstelling is: bloem → bloemen (meervoud op -en) + vaas = bloemenvaas. De tussen-n komt van het meervoud. Andere voorbeelden: boekenplank, pannenkoek, fietsenrek.",
        "solutionSteps": [
          "Lees de zin en zoek het woord dat er niet goed uitziet",
          "'Bloemevase' — klopt de verbindingsklank? Nee, de -n ontbreekt",
          "Bloem → bloemen (meervoud op -en) → tussen-n nodig",
          "Verbetering: bloemenvaas (bloemen + vaas)"
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-005",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "fill_in",
      "question": "Maak een samenstelling van 'fiets' en 'rek'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["fietsenrek"],
        "caseSensitive": false,
        "placeholder": "typ het woord"
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Fietsen + rek", "content": "Fiets → fietsen (meervoud op -en).\nfietsen + rek = fietsenrek.\n\nDe tussen-n komt van het meervoud. Spreek het uit: fietsen-rek.", "icon": "book"}}
      ],
      "conceptId": "linking_n_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Fiets → fietsen (meervoud op -en). In de samenstelling gebruik je het meervoud: fietsen + rek = fietsenrek. Spreek het uit: je hoort 'fietsen-rek'.",
        "solutionSteps": [
          "Eerste deel: fiets",
          "Meervoud: fiets → fietsen (-en)",
          "Samenstelling: fietsen + rek = fietsenrek"
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-004",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "options": ["boekeplank", "boekenplank", "boekplank", "boekensplank"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Boeken + plank", "content": "Boek → boeken (meervoud op -en).\nboeken + plank = boekenplank.\n\nDe tussen-n komt van het meervoud. Andere voorbeelden: boekenkast, boekentas, boekenrek.", "icon": "book"}}
      ],
      "conceptId": "linking_n_boekenplank",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Boek → boeken (meervoud op -en). In de samenstelling gebruik je het meervoud: boeken + plank = boekenplank. Andere voorbeelden: boekenkast, boekentas.",
        "solutionSteps": [
          "Eerste deel: boek",
          "Meervoud: boek → boeken (-en)",
          "Samenstelling: boeken + plank = boekenplank"
        ],
        "distractorExplanations": {
          "0": "'Boekeplank' mist de n. Het meervoud is 'boeken' (met n): boekenplank.",
          "1": "Goed! Boek → boeken (meervoud) → boekenplank.",
          "2": "'Boekplank' heeft geen verbindingsklank. Je hebt het meervoud nodig: boeken + plank.",
          "3": "'Boekensplank' heeft een extra s. Er is geen tussen-s nodig: boeken + plank = boekenplank."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.tussen-n-vergeten", "label": "Tussen-n vergeten (boeke-)", "optionIndex": 0 },
          { "id": "spr.tussen-n-enkelvoud", "label": "Enkelvoud i.p.v. meervoud", "optionIndex": 2 },
          { "id": "spr.tussen-s-verward-en", "label": "Extra -s toegevoegd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-008",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "fill_in",
      "question": "Maak een samenstelling van 'koek' en 'pan'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["koekenpan", "koekepan"],
        "caseSensitive": false,
        "placeholder": "typ het woord"
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Koeken + pan", "content": "Koek → koeken (meervoud op -en).\nkoeken + pan = koekenpan.\n\nDe tussen-n komt van het meervoud. Spreek het uit: koeken-pan. Let op: 'koekepan' (zonder n) wordt ook geaccepteerd — beide vormen komen voor.", "icon": "book"}}
      ],
      "conceptId": "linking_n_fill_koekenpan",
      "variantIndex": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Koek → koeken (meervoud op -en). In de samenstelling gebruik je het meervoud: koeken + pan = koekenpan. Spreek het uit: je hoort 'koeken-pan'. Let op: 'koekepan' (zonder n) wordt ook geaccepteerd — in sommige woordenboeken staan beide vormen. De standaardvorm is 'koekenpan'.",
        "solutionSteps": [
          "Eerste deel: koek",
          "Meervoud: koek → koeken (-en)",
          "Samenstelling: koeken + pan = koekenpan"
        ]
      }
    }
  ]
}
